var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeafGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5078 6.32674C12.3327 8.45448 6.75403 7.98818 3.53517 2.38495C4.19166 2.21009 4.65746 2.95054 6.99856 2.38072C10.3743 1.26733 12.8174 1.89084 15.5078 6.32674Z",
    fill: "#28601A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5262 9.57674C11.6584 13.2991 7.26342 16.7665 1.08625 14.8692C1.44662 14.2933 2.29246 14.5164 3.61427 12.5019C5.32109 9.38384 7.532 8.17176 12.5262 9.57674Z",
    fill: "#54A341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafGreen);
export default __webpack_public_path__ + "static/media/leaf-green.e1b1c7f3f31292671cccb28e4d4a04a1.svg";
export { ForwardRef as ReactComponent };